"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrCatalogsOrderCheckboxVariant = exports.FdrCatalogsOrderButtonVariant = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const components_common_checkbox_1 = require("@hotelplan/components.common.checkbox");
const fdr_catalogs_order_control_styles_1 = require("./fdr-catalogs-order-control.styles");
const FdrCatalogsOrderButtonVariant = ({ ordered, onOrder, }) => {
    return (react_1.default.createElement(fdr_catalogs_order_control_styles_1.CatalogOrderButton, { icon: { name: ordered ? 'delete' : 'basket' }, onClick: onOrder }));
};
exports.FdrCatalogsOrderButtonVariant = FdrCatalogsOrderButtonVariant;
const FdrCatalogsOrderCheckboxVariant = ({ ordered, onOrder, }) => {
    const [t] = (0, next_i18next_1.useTranslation)(['catalogs']);
    return (react_1.default.createElement(fdr_catalogs_order_control_styles_1.CheckboxWrapper, null,
        react_1.default.createElement(components_common_checkbox_1.Checkbox, { name: "subscribe", value: ordered ? 'order' : undefined, checked: ordered, content: t('catalogs:order'), onChange: onOrder })));
};
exports.FdrCatalogsOrderCheckboxVariant = FdrCatalogsOrderCheckboxVariant;
//# sourceMappingURL=fdr-catalogs-order-control.js.map